import React, { PropsWithChildren } from 'react';
import { Level, Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import Byline from './components/Byline';
import Title from './components/Title';

const responsiveWrapperStyles = css({
    width: '100%',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    md: {
        maxWidth: '100vw',
    },
});

export type PageHeadingProps = {
    title?: string;
    byline?: string;
    icon?: JSX.Element;
    cta?: JSX.Element;
    isLoading?: boolean;
};

const PageHeadingWrapper: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Level minHeight="md" className={responsiveWrapperStyles}>
            <Box mr="sm">{children}</Box>
        </Level>
    );
};

const PageHeadingWrapperWithCta: React.FC<PropsWithChildren> = ({
    children,
}) => {
    return (
        <Level className={responsiveWrapperStyles} maxWidth="100%">
            <Box
                mr="sm"
                display="flex"
                justifyContent="space-between"
                width="100%"
                flex={{ base: '0 1 50%', md: '0 1 100%' }}
            >
                {children}
            </Box>
        </Level>
    );
};

const PageHeading: React.FC<PageHeadingProps> = ({
    title = '',
    byline,
    icon,
    cta,
    isLoading = false,
}) => {
    return cta ? (
        <PageHeadingWrapperWithCta>
            <Title isLoading={isLoading} title={title} icon={icon} />
            <Byline isLoading={isLoading} byline={byline} />
            <Box
                display="flex"
                alignItems="flex-end"
                mb={{
                    base: 'none',
                    md: '10px',
                }}
                p="none"
                m="none"
            >
                {cta}
            </Box>
        </PageHeadingWrapperWithCta>
    ) : (
        <PageHeadingWrapper>
            <Title isLoading={isLoading} title={title} icon={icon} />
            <Byline isLoading={isLoading} byline={byline} />
        </PageHeadingWrapper>
    );
};

export default PageHeading;
